import styled from "@emotion/styled";
import { grid, Icon, fonts, colors } from "@trustpilot/businessapp-patternlibrary";

export const StyledAccountsList = styled.ul({
  background: "var(--elevation-surface)",
  margin: "-24px -32px -32px",
  lineHeight: "71px",
  fontSize: "0.875rem",
  position: "relative",
  listStyleType: "none",
  padding: "0",
  maxHeight: "360px",
  overflowY: "auto",
});

export const OrganizationIconArea = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "var( --divider-subtle)",
  borderRadius: "4px 4px 4px 4px",
  marginRight: grid.small,
  height: 36,
  width: 36,
});

export const CenteredDiv = styled.div({
  display: "flex",
  alignItems: "center",
});

export const AccountNameContainer = styled.div({
  fontWeight: fonts.weights.medium,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "inline-block",
  paddingRight: 16,
});

export const ArrowIcon = styled(Icon)({
  position: "absolute",
  right: 36,
  width: 12,
  height: 12,
});

export const CenteredPulledRightDiv = styled.div({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
  justifyContent: "flex-end",
});

export const StyledAccountsListItem = styled.li({
  display: "flex",
  background: "var(--neutral-white)",
  margin: 0,
  lineHeight: "71px",
  fontSize: "0.875rem",
  position: "relative",
  listStyleType: "none",
  padding: `0 ${grid.large}px`,
  cursor: "pointer",
  "&:not(:last-of-type)": {
    borderBottom: `1px solid var( --divider-subtle)`,
  },
  "&:hover": {
    background: "#fafbfc",
  },
});

export const StyledTertiaryActionArea = styled.div({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  background: colors.gray.lightBackground,
  height: 72,
  padding: "24px 32px",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
});

export const StyledToggleText = styled.div({
  paddingLeft: 16,
  cursor: "pointer",
});
